<template>
  <div>
    <div class="top-breadcrumb">
      <ol class="breadcrumb" style="background-color: white">
        <li class="breadcrumb-item" style="margin-left: 15px">
          <router-link to="" style="color: #8cc63f !important">
            Portfolio Management
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link
            style="color: #8cc63f !important"
            :to="'/' + authUser.userable_type + '/assets'"
            >Assets</router-link
          >
        </li>
      </ol>
    </div>
    <div
      style="display: flex; justify-content: center; margin-top: 60px"
      class="col-12"
    >
      <div style="display: flex; justify-content: space-between" class="col-10">
        <span
          class="col-3"
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            color: gray;
          "
        >
          <i
            class="fa fa-filter"
            style="font-size: 15px; color: #8cc63f; margin-right: 5px"
          ></i>
          Filter
        </span>
        <span class="col-5">
          <input
            @change="filter()"
            v-model="keyword"
            type="text"
            class="form-control"
            placeholder="Keyword"
            style="padding: 10px"
          />
        </span>
      </div>
    </div>
    <div style="display: flex; justify-content: center; margin-top: 50px">
      <div
        style="display: flex; justify-content: center; cursor: pointer"
        @click="toggleCreateAssetModal()"
      >
        <div>
          <i
            class="fa fa-plus-circle"
            style="font-size: 90px; color: #8cc63f; margin-right: 5px"
          ></i>
        </div>
        <div
          style="
            display: flex;
            align-items: center;
            flex-direction: column;
            margin: 0;
            justify-content: center;
            margin-left: 10px;
          "
        >
          <p
            style="
              margin: 0px;
              font-size: 40px;
              margin-bottom: 5px;
              color: #8cc63f;
            "
          >
            ADD
          </p>
          <p style="margin: 0; color: #8cc63f; font-size: 14px">new asset</p>
        </div>
      </div>
    </div>
    <spinner v-if="searchingAssets" />
    <pagination
      v-else
      @updateAsset="toggleUpdateAssetModal"
      @deleteAsset="deleteAsset"
      style="padding: 0 50px"
      :data="assetsPaginated"
      scope="props"
      itemTemplate="asset"
      :classes="['assetClass', 'col-12']"
    ></pagination>
    <div style="display: flex; padding: 0 50px">
      <div class="col-6">
        <md-card
          class="md-card-stats"
          style="
            background-color: white;
            border-radius: 15px;
            padding: 40px;
            height: 300px;
          "
        >
          <h5>Asset Allocations</h5>

          <spinner style="margin-top: 60px" v-if="searchingAssets" />
          <pie-chart
            v-else
            style="height: 200px"
            :chart-data="pieChartData"
            :options="chartOptions"
          ></pie-chart>
        </md-card>
      </div>
      <div class="col-6">
        <md-card
          class="md-card-stats"
          style="
            background-color: white;
            border-radius: 15px;
            padding: 40px;
            height: 300px;
          "
        >
          <h5>Asset Objective</h5>
          <spinner style="margin-top: 60px" v-if="searchingAssets" />

          <bar-chart
            v-else
            :style="barChartData.labels.length > 0 ? 'width: 100%;' : ''"
            style="height: 200px"
            :chart-data="barChartData"
            :labels="{
              x: {
                display: true,
              },
              y: {
                display: true,
              },
            }"
          ></bar-chart>
        </md-card>
      </div>
    </div>
    <asset-modal
      :active="showAssetModal"
      :actionType="actionModalType"
      :activeAsset="activeAsset"
      @saveRequest="handleSave"
      @closeRequest="
        actionModalType == 'createModal'
          ? toggleCreateAssetModal()
          : toggleUpdateAssetModal()
      "
    />
  </div>
</template><script>
import AssetModal from "./components/modals/assetModal.vue";
import sweetAlert from "sweetalert2";
import Pagination from "../common/Pagination.vue";
import AssetsFilter from "../../filters/AssetsFilter";
import { mapState } from "vuex";
import Spinner from "vue-simple-spinner";
import { PieChart, BarChart } from "../../components/ChartJS";

export default {
  name: "asset",
  data() {
    return {
      selectedAssetId: null,
      actionModalType: null,
      showAssetModal: false,
      activeAsset: null,
      keyword: "",
      pieChartData: {
        labels: [],
        datasets: [],
      },
      barChartData: {
        labels: [],
        datasets: [],
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true,
          position: "left",
        },
        tooltips: {
          displayColors: false,
          callbacks: {
            label: function (tooltipItem, data) {
              let dataset = data.datasets[tooltipItem.datasetIndex];
              let currentValue = dataset.data[tooltipItem.index];
              return (
                data.labels[tooltipItem.index] +
                " (" +
                currentValue +
                "%)"
              );
            },
          },
        },
        animation: {
          duration: 0,
        },
        hover: {
          animationDuration: 0,
        },
        responsiveAnimationDuration: 0,
      },
    };
  },
  components: {
    AssetModal,
    PieChart,
    BarChart,
    Pagination,
    Spinner,
  },
  created: function () {
    var assetsFilter = AssetsFilter();
    this.$store.dispatch("searchAssets", {
      filter: assetsFilter,
      resultMode: "paginated",
    });
  },
  computed: {
    ...mapState({
      authUser: (state) => state.userStore.authUser,
      assetsPaginated: (state) => state.assetStore.assetSearch.assetsPaginated,
      assets: (state) => state.assetStore.assetSearch.assets,
      createAssetStatus: (state) =>
        state.assetStore.assetCreate.createAssetStatus,
      updateAssetStatus: (state) =>
        state.assetStore.assetUpdate.updateAssetStatus,
      deleteAssetStatus: (state) =>
        state.assetStore.assetDelete.deleteAssetStatus,
      searchingAssets: (state) => state.assetStore.assetSearch.searchingAssets,
    }),
  },
  methods: {
    init() {
      this.selectedAssetId = null;
      this.actionModalType = null;
      this.showAssetModal = false;
      var assetsFilter = AssetsFilter();
      this.$store.dispatch("searchAssets", {
        filter: assetsFilter,
        resultMode: "paginated",
      });
    },

    filter() {
      var assetsFilter = AssetsFilter();
      assetsFilter.text = this.keyword;
      this.$store.dispatch("searchAssets", {
        filter: assetsFilter,
        resultMode: "paginated",
      });
    },

    formValidation(asset) {
      const result = { isValid: true, message: "" };
      result.message += "Please fill all required fields";
      let missingFieldsString = "";

      if (!asset.name) {
        missingFieldsString += "Asset name is empty, ";
        result.isValid = false;
      }
      if (!asset.description) {
        missingFieldsString += "Asset description is empty, ";
        result.isValid = false;
      }
      if (!asset.cluster_id) {
        missingFieldsString += "Cluster is not selected, ";
        result.isValid = false;
      }
      if (!asset.media_id) {
        missingFieldsString += "Asset media is not selected, ";
        result.isValid = false;
      }

      if (missingFieldsString.length > 0) {
        // remove trailing comma
        missingFieldsString = missingFieldsString.substring(
          0,
          missingFieldsString.length - 2
        );
        result.message += ` (${missingFieldsString})`;
      }
      return result;
    },
    handleSave(asset) {
      const { isValid, message } = this.formValidation(asset);
      if (!isValid) {
        sweetAlert({
          title: "Error",
          text: message,
          type: "error",
          confirmButtonText: "Return",
        });
        return;
      }
      if (this.actionModalType == "createModal") {
        this.createAsset(asset);
      } else {
        this.updateAsset(asset);
      }
    },
    createAsset(asset) {
      this.$store.dispatch("createAsset", asset);
    },
    updateAsset(asset) {
      this.$store.dispatch("updateAsset", asset);
    },
    deleteAsset(id) {
      sweetAlert({
        title: "Confirmation",
        text: "Are you sure you want to delete this asset?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.value) {
          this.$store.dispatch("deleteAsset", id);
        }
      });
    },
    toggleCreateAssetModal() {
      this.showAssetModal = !this.showAssetModal;
      this.showAssetModal ? (this.actionModalType = "createModal") : null;
    },
    toggleUpdateAssetModal(asset) {
      this.showAssetModal = !this.showAssetModal;
      if (this.showAssetModal) {
        this.actionModalType = "updateModal";
        this.activeAsset = asset;
      } else {
        this.actionModalType = null;
        this.activeAsset = null;
      }
    },
  },
  watch: {
    assetsPaginated() {
      if (this.assetsPaginated.data && this.assetsPaginated.data.length > 0) {
        var labels = [];
        var data = [];
        this.assetsPaginated.data.forEach((asset) => {
          labels.push(asset.name);
          data.push(asset.asset_allocation_ratio.toFixed(2));
        });
        this.pieChartData.labels = labels;
        this.pieChartData.datasets = [
          {
            label: "Asset Allocations",
            data: data,
            backgroundColor: [
              "#8cc63f",
              "rgb(255, 99, 132)",
              "rgb(54, 162, 235)",
              "rgb(255, 205, 86)",
              "rgb(32, 133, 236)",
              "rgb(114, 180, 235)",
              "rgb(10, 65, 122)",
              "rgb(132, 100, 160)",
              "rgb(206, 169, 188)",
              "rgb(50, 50, 50)",
              "rgb(223, 199, 49)",
              "rgb(234, 136, 216)",
              "rgb(17, 51, 103)",
              "rgb(151, 105, 142)",
              "rgb(186, 199, 193)",
              "rgb(60, 60, 60)",
            ],
            hoverOffset: 4,
          },
        ];
      }
    },
    createAssetStatus() {
      if (this.createAssetStatus == "success") {
        sweetAlert({
          title: "Success",
          text: "Asset has been created successfully",
          icon: "success",
          confirmButtonText: "Done",
        }).then(() => {
          this.init();
        });
      } else if (this.createAssetStatus == "failed") {
        sweetAlert({
          title: "Failed",
          text: "Asset creation has failed",
          IntersectionObserver: "error",
          confirmButtonText: "Return",
        });
      }
    },
    updateAssetStatus() {
      if (this.updateAssetStatus == "success") {
        sweetAlert({
          title: "Success",
          text: "Asset has been updated successfully",
          icon: "success",
          confirmButtonText: "Done",
        }).then(() => {
          this.init();
        });
      } else if (this.updateAssetStatus == "failed") {
        sweetAlert({
          title: "Failed",
          text: "Asset update has failed",
          IntersectionObserver: "error",
          confirmButtonText: "Return",
        });
      }
    },
    deleteAssetStatus() {
      if (this.deleteAssetStatus == "success") {
        sweetAlert({
          title: "Success",
          text: "Asset has been deleted successfully",
          icon: "success",
          confirmButtonText: "Done",
        }).then(() => {
          this.init();
        });
      } else if (this.deleteAssetStatus == "failed") {
        sweetAlert({
          title: "Failed",
          text: "Asset delete has failed",
          IntersectionObserver: "error",
          confirmButtonText: "Return",
        });
      }
    },
  },
};
</script> 
 <style>
.md-ripple {
  padding: 0px !important;
}
.table.vgt-table {
  font-size: 20px;
}
.form-control {
  border: 1px solid #ced4da !important;
  background-image: none;
  padding: 5px;
  border-radius: 5px !important;
}
.assetClass {
  display: flex;
  flex-flow: wrap;
  justify-content: space-between;
}
</style>


// WEBPACK FOOTER //
// resources/js/pages/admin/assets.vue